import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

//Projects
import ProjectsList from '../Projects/ProjectsList';
import { Layout, LayoutPanel  } from 'rc-easyui';
import ApiUtils from "../../helper/ApiUtils";
// import axios from "axios";
// import setAuthToken from "../../utils/setAuthToken";
// import jwt_decode from "jwt-decode";
// import {setCurrentUser} from "../../actions/authActions";

import 'bootstrap/dist/css/bootstrap.min.css';

import { Navbar,Nav,NavDropdown } from 'react-bootstrap';


class Corporate extends Component {
    constructor(props) {
        super(props);


        this.state = {
        };
    }


    async componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }
    }

    render() {



        return (<div>
            <Navbar bg="light" expand="lg">
                <Navbar.Brand href="#home">SubPro</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Link href="#home">Home</Nav.Link>
                        <Nav.Link href="#link">Link</Nav.Link>
                        <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>);

    }
}


Corporate.propTypes = {
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps, {   })(
    withRouter(Corporate)
);


// WEBPACK FOOTER //
// ./src/components/layout/Corporate.js